import * as types from './performanceDashboardCombinedActionType';

export const fetchPerformanceDashboardCombinedPowerBIReportRequest = () => ({
    type: types.FETCH_PERFORMANCE_DASHBOARD_COMBINED_POWER_BI_REPORT_REQUEST
});
export const fetchPerformanceDashboardCombinedPowerBIReportSuccess = (data) => ({
    type: types.FETCH_PERFORMANCE_DASHBOARD_COMBINED_POWER_BI_REPORT_SUCCESS,
    payload: data
});
export const fetchPerformanceDashboardCombinedPowerBIReportFailure = (error) => ({
    type: types.FETCH_PERFORMANCE_DASHBOARD_COMBINED_POWER_BI_REPORT_FAILURE,
    payload: error
});

export const fetchPerformanceDashboardCombinedLastRefreshedRequest = () => ({
    type: types.FETCH_PERFORMANCE_DASHBOARD_COMBINED_LAST_REFRESHED_REQUEST
});
export const fetchPerformanceDashboardCombinedLastRefreshedSuccess = (dateTime, nextRefreshDateTime = null) => ({
    type: types.FETCH_PERFORMANCE_DASHBOARD_COMBINED_LAST_REFRESHED_SUCCESS,
    payload: { lastRefreshedDateTime: dateTime, nextRefreshDateTime }
});
export const fetchPerformanceDashboardCombinedLastRefreshedFailure = (error) => ({
    type: types.FETCH_PERFORMANCE_DASHBOARD_COMBINED_LAST_REFRESHED_FAILURE,
    payload: error
});
